import { CONFIG } from '../app/config';
import { store } from "./store";
import WPJSApi from './includes/wpjswrapper';

let WPJSApiSettings = WPJSApi.create('custom', 'settings', 'v2');


const registeredHooks = [];
export const registerCustomHook = (action, cb) => {
	registeredHooks.push({
		action: action,
		cb: cb
	});
};

export const triggerHook = (action, args) => {
	let result = true;
	registeredHooks.filter(hook => hook.action === action).forEach((hook) => {
		result = hook.cb(args);
	})
	return result;
};

export const getPage = (dispatch, params, hash, query) => {

	let callback = () => {

		let page = PageHelper.create();

		let getParams = getUrlVars();

		let isPreviewMode = getParams['preview'];

		//Args for custom code
		let args = {
			params: params,
			hash: hash,
			query: query
		}

		if (!triggerHook('onBeforeEvaluatingPage', {dispatch: dispatch, args: args, page: page})) return;

		let search = getSearchSlug(params);

		let cachedPages = store.getState().pagePasswordState.pages;
		if (cachedPages) {
			let cacheIndex = cachedPages.map(page => page.slug).indexOf(search);
			if (cacheIndex >= 0) {
				params.id = cachedPages[cacheIndex].id;
				query = { password:  cachedPages[cacheIndex].password }
			}
		}

		let preloadedPage = getPreloadedPage(search);
		if (preloadedPage !== null && !isPreviewMode) {
			dispatch({
				type: 'PAGE_LOADING'
			});

			setTimeout(() => {
				dispatch({
					type: 'PAGE_PRE_LOADED',
					page: {
						loaded: false,
						title: preloadedPage.title,
						template: preloadedPage.is_front_page ? 'index' : PageHelper.cleanTemplateName(preloadedPage.template),
						fields: preloadedPage.fields,
						custom: preloadedPage.custom,
						meta_seo: preloadedPage.meta_seo
					},
					head: {
						title: getPageTitle(preloadedPage.meta_seo.title),
						description: getPageDescription(preloadedPage.meta_seo.description)
					}
				})
			}, 0);
		} else if (!params.id) {
			dispatch({
				type: 'PAGE_LOADING'
			})
		}

		dispatch({
			type: 'MENU_CURRENT',
			ancestors: Object.values(params)
		})

		let endpoint = WPJSApi.Pages;
		let req = null;

		if (typeof _nonce !== 'undefined') {
			req = {};
			req._wpnonce = _nonce;
		}

		if (CONFIG.multiLangSupport) {
			if (req == null) {
				req = {};
			}
			req.lang = getCurrentSiteLanguage();
		}

		if (params.sub || params.sub2) {
			CONFIG.customPostTypes.forEach((cpt) => {
				if (cpt.rewrite.indexOf('/') >= 0 && params.page+'/'+params.sub === cpt.rewrite) {
					endpoint = WPJSApi.create('wp', cpt.endpoint ? cpt.endpoint : cpt.type, 'v2');
					page.type = cpt.type;
				} else if (params.page === cpt.rewrite) {
					endpoint = WPJSApi.create('wp', cpt.endpoint ? cpt.endpoint : cpt.type, 'v2');
					page.type = cpt.type;
				}
			})
		}

		let request;

		if (params.id) {
			request = WPJSApi.Pages.get.bind(null, params.id, query);
		} else {
			// /lbb/v2/fetch/type/slug/lang
			endpoint = WPJSApi.create('lbb', 'fetch/'+page.type+'/'+search, 'v2')
			request = endpoint.list.bind(null, req);
		}

		if (isPreviewMode) {
			let preparation = preparePreviewRequest(getParams, page);
			if (preparation) {
				request = preparation.request;
				page = preparation.page;
			}
		}

		if (!triggerHook('onBeforeLoadingPage', {dispatch: dispatch, args: args, page: page, search: search})) return;

		request().then((rsp) => {

			page.loaded = true;
			if (rsp.length > 0 || params.id) {
				let response_object = params.id ? rsp : rsp[0];
				page = PageHelper.prepare(response_object, page);

				//If protected content, remove it.
				if (response_object.content.protected && !params.id) {
					page = PageHelper.protect(page);
				}

				triggerHook('onSuccessLoadingPage', {dispatch: dispatch, args: args, response_object: response_object, page: page});
			}

			dispatch({
				type: 'PAGE_LOADED',
				page: page,
				head: {
					title: getPageTitle(page.meta_seo.title),
					description: getPageDescription(page.meta_seo.description)
				}
			})

			//Enable revisions
			if (isPreviewMode) {
				dispatch({
					type: 'PAGE_REVISIONS_LOADED',
					revisions: rsp.map((item) => {
						item.template = PageHelper.cleanTemplateName(item.template)
						return item;
					}),
					revision: 0
				})
			}

			if (hash) {
				scrollToElementByHash(hash);
			}

		}).catch((error) => {
			page.title = CONFIG.page_404.title
			page.slug = CONFIG.page_404.slug;
			page.template = CONFIG.page_404.template;
			page.content = CONFIG.page_404.content
			page.meta_seo = {
				title: CONFIG.page_404.title,
				description: CONFIG.page_404.description
			}

			dispatch({
				type: 'PAGE_LOADED',
				page: page
			})
			triggerHook('onNotFoundLoadingPage', {dispatch: dispatch, args: args, page: page});


			logError('page_load', 'Failed to load page');


		})

	}

	if (store.getState().generalState.general) {
		callback();
	} else {
		loadConfig(store.dispatch, callback);
	}
}

export const getProtectedPage = (params, query) => {

	let page = store.getState().pageState.page;

	let dispatch = store.dispatch;

	if (query.password) {

		dispatch({
			type: 'PAGE_LOADING'
		})

		WPJSApi.Pages.get(params.id, { password: query.password }).then((rsp) => {

			page.loaded = true;

			dispatch({
				type: 'PAGE_PASSWORD_SET',
				id: params.id,
				slug: rsp.slug,
				password: query.password
			})

			page = PageHelper.prepare(rsp, page);

			dispatch({
				type: 'PAGE_LOADED',
				page: page
			})

		}).catch((e) => {
			dispatch({
				type: 'PAGE_LOADED',
				page: page
			})
		})
	}
}

export const getPageTitle = (title) => {
	return title;
}

export const getPageDescription = (desc) => {
	return desc ? desc : store.getState().generalState.general.description;
}

export const loadConfig = (dispatch, cb) => {

	let req = {};

	if (typeof _nonce !== 'undefined') {
		req._wpnonce = _nonce;
	}

	if (CONFIG.multiLangSupport) {
		req.lang = getCurrentSiteLanguage();
	}

	if (Object.keys(req).length === 0) {
		req = null;
	}


	let callback = (rsp) => {

		CONFIG.defaultPageSlug = rsp.config.defaultPageSlug;
		CONFIG.customPostTypes = rsp.config.cpt;
		CONFIG.page_404		   = {...CONFIG.page_404, ...rsp.config.page_404};
		CONFIG.components 	   = rsp.config.components;

		triggerHook('onSettingsLoaded', {dispatch:dispatch, rsp: rsp});

		dispatch({
			type: 'MENUS_LOADED',
			menus: rsp.menus
		});

		dispatch({
			type: 'GENERAL_LOADED',
			general: rsp.general,
			sitemap: rsp.sitemap ? rsp.sitemap : [],
			settings: rsp.settings,
			footer: rsp.footer
		});

		if (rsp.logged_in) {
			dispatch({
				type: 'ADMIN_LOADED',
				data: rsp.logged_in
			})
		}

		if (cb) {
			cb();
		}
	};

	if (typeof lbb_settings_data !== 'undefined') {
		callback(lbb_settings_data);
	} else {
		WPJSApiSettings.list(req).then(callback).catch((e) => {
            dispatch({
                type: 'GENERAL_LOADED'
            });
            dispatch({
                type: 'PAGE_LOADED',
                page: {}
            });

            logError('settings_load','Error loading settings data');
        });
	}

}

const getPreloadedPage = (search) => {
	let sitemap = [];

	if (store.getState().generalState.sitemap) {
		sitemap = store.getState().generalState.sitemap;
	}

	let index = sitemap.map((page) => {
		return page.slug;
	}).indexOf(search);

	return index >= 0 ? sitemap[index] : null;
}

const PageHelper = {
	create: () => {
		return {
			title: '',
			slug: '',
			template: '',
			content: '',
			meta_seo: null,
			protected: false,
			type: 'page',
			fields: {},
			custom: {}
		}
	},
	prepare: (rsp, page) => {
		page.id = rsp.id;
		page.title = rsp.title.rendered;
		page.template = rsp.template ? PageHelper.cleanTemplateName(rsp.template) : null;
		page.content = rsp.content.rendered;
		page.meta_seo = rsp.meta_seo;
		page.fields = rsp.fields ? rsp.fields : {};
		page.custom = rsp.custom ? rsp.custom : {};
		page.protected = false;
		page.revision = rsp.revision;
		page.slug = rsp.slug;

		if (rsp.admin_edit_url) {
			page.admin_edit_url = rsp.admin_edit_url;
		}

		if (rsp.is_front_page) {
			page.template = 'index';
		}

		if (page.type !== 'page' && page.template == null) {
			page.template = page.type+'-single';
		}

		return page;
	},
	protect: (page) => {
		page.protected = true;
		page.content = null;
		page.fields = {};
		page.custom = {};
		return page;
	},
	cleanTemplateName: (template) => {
		return template.replace("template-", "").replace(".php", "")
	}
}

const preparePreviewRequest = (page) => {

	let getParams = getUrlVars();

	if (typeof _nonce !== 'undefined') {

		let preview_id = getParams['p'];
		if (getParams['id']) {
			preview_id = getParams['id'];
		}
		if (getParams['page_id']) {
			preview_id = getParams['page_id'];
		}
		if (getParams['preview_id']) {
			preview_id = getParams['preview_id'];
		}

		let WPJSApiRevisions = WPJSApi.create('wp', 'pages/'+preview_id+'/revisions', 'v2');
		if (getParams['type'] === 'post') {
			WPJSApiRevisions = WPJSApi.create('wp', 'posts/'+preview_id+'/revisions', 'v2');
			page.type = 'post';
		} else if (getParams['type'] !== 'page') {
			WPJSApiRevisions = WPJSApi.create('wp', getParams['type']+'/'+preview_id+'/revisions', 'v2');
			page.type = getParams['type'];
		}

		return {
			request: WPJSApiRevisions.list.bind(null, {'_wpnonce' : _nonce}),
			page: page
		};
	}

	console.error('Trying to get page revisions but no auth token, must run inside wp environment.')
	return null;
}

const getSearchSlug = (params) => {
	let search = CONFIG.defaultPageSlug;
	if (params.page) {
		search = params.page;
	}

	if (CONFIG.multiLangSupport && CONFIG.multiLangMode === 'path') {
		let paths = window.location.pathname.split('/').filter(n => n);
		if (paths.length > 0) {
			let langIndex = CONFIG.routing.map(item => item.path).indexOf(paths[0]);
			if (langIndex >= 0) {
				search = CONFIG.defaultPageSlug;
			}
		}
	}

	if (params.sub) {
		search = params.sub;
	}
	if (params.sub2) {
		search = params.sub2;
	}
	if (params.sub3) {
		search = params.sub3;
	}
	if (params.sub4) {
		search = params.sub4;
	}

	if (triggerHook('modifySearchSlug', params) !== true) {
		search = triggerHook('modifySearchSlug', params);
	}

	return search;
}

const scrollToElementByHash = (hash) => {
	setTimeout(() => {
		let element = document.getElementById(hash.replace('#', ''));
		if (element) {
			window.scrollTo(0, element.getBoundingClientRect().top);
		}
	}, 50)
}

const getUrlVars = () => {
	let vars = {};
	window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
		vars[key] = value;
	});
	return vars;
}

export const getMenuHierarchy = (menu, id, levels) => {
	let items = [];
	if (levels >= 0) {
		items = menu.items.filter(item => item.parent === id);
		items = items.map((item) => {
			item.children = getMenuHierarchy(menu, item.id, levels - 1)
			return item;
		})
	}
	return items;
}

export const getCurrentSiteLanguage = () => {
	let langIndex = -1;
	if (CONFIG.multiLangMode === 'domain') {
		langIndex = CONFIG.routing.map(item => item.domain).indexOf(window.location.hostname);
	} else if (CONFIG.multiLangMode === 'path') {
		let paths = window.location.pathname.split('/').filter(n => n);
		if (paths.length > 0) {
			langIndex = CONFIG.routing.map(item => item.path).indexOf(paths[0]);
		}
	}

	let standard = CONFIG.routing[0];

	let lang = langIndex >= 0 ? CONFIG.routing[langIndex].lang : standard.lang;

	let getParams = getUrlVars();
	if (getParams.lang) {
		lang = getParams.lang;
	}

	return lang;
}

export const logError = (type, error) => {
	console.log(window.location.href, type, error);
}